"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/PageNotFoundScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _Form = require('web/components/Form');

var _TemplateEntityScreen = require('./TemplateEntityScreen'); var _TemplateEntityScreen2 = _interopRequireDefault(_TemplateEntityScreen);



const collectSections = (tree, into) => {
  if (typeof tree === 'string') {
    const section = tree.split('/')[1]
    if (section && !section.startsWith(':')) into.add(section)
    return into
  }
  Object.values(tree).forEach(child => collectSections(child, into))
  return into
}

const KNOWN_SECTIONS = collectSections(_routes2.default, new Set())

// The 404 log goes to the unauthenticated /log endpoint, and a mistyped path
// can carry tokens or form codes. Name only the app section it fell under.
 const notFoundLogPath = (pathname) => {
  const [section = '', ...rest] = pathname.split('/').filter(Boolean)
  if (!section) return '/'
  if (!KNOWN_SECTIONS.has(section)) return '/(unknown)'
  return rest.length > 0 ? `/${section}/…` : `/${section}`
}; exports.notFoundLogPath = notFoundLogPath

const PageNotFoundScreen = () => {
  const { pathname } = _reactrouterdom.useLocation.call(void 0, )
  _react.useEffect.call(void 0, () => {
    _client2.default.log({ message: `404: ${exports.notFoundLogPath.call(void 0, pathname)}` })
      .catch(() => null)
  }, [pathname])

  return (
    _react2.default.createElement(_TemplateEntityScreen2.default, {
      iconSrc: "/assets/icons/broken-link-pale-purple.svg",
      title: "404",
      desc: 
        _react2.default.createElement('div', { className: "not-found--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "The requested page doesn't exist."    )
          , _react2.default.createElement(_reactrouterdom.Link, { to: _routes2.default.ROOT, className: "not-found--btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
            , _react2.default.createElement(_Form.Button, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}, "Go back" )
          )
        )
      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
    )
  )
}

exports. default = PageNotFoundScreen
